/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum HistoricoRequisicoesAliases {
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  CUSTOM_CARD_REQUISICAO = 'custom-card-requisicao',
  DATE_FIELD_0 = 'date-field-0',
  DATE_FIELD_1 = 'date-field-1',
  DECK = 'deck',
  FETCH_REQUISICAO = 'fetch-requisicao',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FIELD_3 = 'field-3',
  FIELD_4 = 'field-4',
  FIELD_5 = 'field-5',
  FIELD_6 = 'field-6',
  FIELD_8 = 'field-8',
  FIELD_9 = 'field-9',
  FIELD_10 = 'field-10',
  FIELD_11 = 'field-11',
  FILTER = 'filter',
  FILTERED_LIST_0 = 'filtered-list-0',
  HPMS_CUSTOM_CARD_CONTENT_COLLAPSE = 'hpms-custom-card-content-collapse',
  HPMS_DYNAMIC_CONTENT_FIELD_COLLPASE = 'hpms-dynamic-content-field-collpase',
  HPMS_DYNAMIC_CONTENT_FIELD_DETAILS = 'hpms-dynamic-content-field-details',
  HPMS_DYNAMIC_CONTENT_FIELD_ESTAGIO = 'hpms-dynamic-content-field-estagio',
  INPUT_0 = 'input-0',
  INPUT_1 = 'input-1',
  LAYOUT_HISTORICO_REQUISICOES = 'layout-historico-requisicoes',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_3 = 'text-3',
  TEXT_5 = 'text-5',
  TEXT_6 = 'text-6',
  TEXT_7 = 'text-7',
}
export { HistoricoRequisicoesAliases };
